// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"383121d4","732":"cb4b4959","977":"3baadeea"}[chunkId] + ".chunk.js";
};